import React from 'react';
import { Page, TLCode } from '../../common/enums';
import VerticalForm from '../common/form/VerticalForm';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Instance } from 'mobx-state-tree';
import styled from '@emotion/styled';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';
import { inject } from 'mobx-react';
import { ApplicationStore, GroupStore, AnchorStore, PharmacyStatusStore, PharmacyDetailedStore } from '../../store';
import {
  Button,
  Column,
  DataGrid,
  DataGridTypes,
  Export,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  Sorting,
  Scrolling
} from 'devextreme-react/cjs/data-grid';
import { Switch } from 'devextreme-react/switch';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import DataSource from 'devextreme/data/data_source';
import { PharmacyStatusCell } from '../common/grid/PharmacyStatusCell';
import { CheckBox } from 'devextreme-react';
import { Classes, Dialog, Intent } from '@blueprintjs/core';
import { Button as Button2 } from '@blueprintjs/core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface NeighborsPanelProps extends WithTranslateProps {
  pharmacyDetails: Instance<typeof PharmacyDetails>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  getPharmacy: (id: number) => Instance<typeof PharmacyDetails>;
  isPharmacy: boolean;
  GroupStore?: Instance<typeof GroupStore>;
  AnchorStore?: Instance<typeof AnchorStore>;
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
}

type CellCheckProps = {
  flag: boolean;
  onValueChange: (data) => void;
};

const CellCheck = React.memo((props: CellCheckProps) => (
  <CheckBox value={props.flag} onValueChange={(e) => props.onValueChange(e)} />
));

interface NeighborsPanelState {
  popupVisible: boolean,
  data: Instance<typeof PharmacyDetails> | undefined,
  isForPairing: boolean | undefined,
  isLoading: boolean | undefined,
  newCheckboxValue: boolean | undefined,
}

@inject('GroupStore')
@inject('AnchorStore')
@inject('ApplicationStore')
@inject('PharmacyStatusStore')
@inject('PharmacyDetailedStore')
class NeighborsPanel extends React.Component<NeighborsPanelProps, NeighborsPanelState> {
  constructor(props: NeighborsPanelProps) {
    super(props);
    this.state = {
      popupVisible: false,
      data: undefined,
      isForPairing: true,
      isLoading: false,
      newCheckboxValue: undefined
    };
  }

  async componentDidMount() {
    if (this.props.GroupStore && this.props.GroupStore.dataList.length === 0) {
      await this.props.GroupStore.loadList();
    }
  }

  onPairingChange = async (data) => {
    await this.props.PharmacyDetailedStore!.togglePairingAllowed(this.props.pharmacyDetails.pharmacyId, data.pharmacyId);
    this.forceUpdate();
  };

  onExchangeChange = async (data) => {
    await this.props.PharmacyDetailedStore!.toggleExchangeAllowed(this.props.pharmacyDetails.pharmacyId, data.pharmacyId);
    this.forceUpdate();
  };


  buildGridData = () => {
    const neighbors = this.props.pharmacyDetails.neighbors();
    const filteredNeighbors = neighbors
      .filter((p) => p !== undefined)
      .map(
        (p) =>
          p && {
            ...p,
            pharmacyId: p.pharmacyId,
            apbNumber: p.apbNumber,
            name: p.name,
            level: p.level,
            phone: p.phone,
            address: p.address,
            city: p.city,
            zipCode: p.zipCode,
            density: p.density,
            distance: this.props.pharmacyDetails.pharmacyNeighbors.find((pn) => pn.neighborId === p.pharmacyId)!
              .distance,
            zone: p.zoneId,
            anchor: p.anchorId === undefined ? '' : this.props.AnchorStore!.dataList.find((a) => a.anchorId === p.anchorId)!.name,
            group:
              p.groupId === undefined ? '' : this.props.GroupStore!.dataList.find((g) => g.groupId === p.groupId)!.name,
            pairingAllowed: this.props.pharmacyDetails.pharmacyNeighbors.find((pn) => pn.neighborId === p.pharmacyId)!
              .pairingAllowed,
            pairingAllowedDef: this.props.pharmacyDetails.pharmacyNeighbors.find((pn) => pn.neighborId === p.pharmacyId)!
              .pairingAllowedDef,
            exchangeAllowed: this.props.pharmacyDetails.pharmacyNeighbors.find((pn) => pn.neighborId === p.pharmacyId)!
              .exchangeAllowed,
            exchangeAllowedDef: this.props.pharmacyDetails.pharmacyNeighbors.find((pn) => pn.neighborId === p.pharmacyId)!
              .exchangeAllowedDef,
          },
      );

    return new DataSource({
      store: { type: 'array', key: 'pharmacyId', data: filteredNeighbors },
      langParams: {
        locale: 'fr',
        collatorOptions: {
          sensitivity: 'base',
        },
      },
    });
  };

  onPharmacySelected = (event) => {
    const pharmacyId = event.data.pharmacyId;
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyId}`);
  };

  displayPharmacyStatusCell = (params: any) => {
    const pharmacyStatus = this.props.PharmacyStatusStore!.dataList.find(
      (ps) => ps.pharmacyStatusId === params.row.data.statusId,
    );
    if (pharmacyStatus === undefined) return <></>;
    return <PharmacyStatusCell pharmacyStatus={pharmacyStatus} />;
  };

  openDialog(newValue, data, isForPairing: boolean) {
    this.setState({
      isForPairing,
      data,
      newCheckboxValue: newValue,
      popupVisible: true,
    });
  }


  async validateModification() {
    this.setState({ isLoading: true });

    console.log('isForPairing : ' + this.state.isForPairing);

    if (this.state.isForPairing) {
      await this.onPairingChange(this.state.data);
    } else {
      await this.onExchangeChange(this.state.data);
    }

    this.setState({
      data: undefined,
      isForPairing: undefined,
      isLoading: false,
      popupVisible: false,
    });
  }

  cancelModification() {
    this.setState({
      data: undefined,
      isForPairing: true,
      newCheckboxValue: undefined,
      popupVisible: false,
    });
  }


  onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Pharmacies_list.xlsx');
      });
    });
  };

  render() {
    const { pharmacyDetails, translate, isPharmacy } = this.props;
    const getConfirmationMessage = (pharmacy: Instance<typeof PharmacyDetails>) => {
      var message = '';
      const { isForPairing, newCheckboxValue } = this.state;
      if (isForPairing && newCheckboxValue) {
        message = translate(TLCode.PHARMACY_TogglePairingConfirmationMessage);
      } else if (isForPairing && !newCheckboxValue) {
        message = translate(TLCode.PHARMACY_ToggleRemovePairingConfirmationMessage);
      } else if (!isForPairing && newCheckboxValue) {
        message = translate(TLCode.PHARMACY_ToggleExchangeConfirmationMessage);
      } else {
        message = translate(TLCode.PHARMACY_ToggleRemoveExchangeConfirmationMessage);
      }
      console.log(pharmacy)
      return message.replace('%PHARMACY_NAME%', pharmacy.name + ' (' + pharmacy.apbNumber + ')');
    };
    return (
      <Container>
        <VerticalForm labelWidth={175}>
          <b>
            ({pharmacyDetails!.level})&nbsp;&nbsp;{pharmacyDetails.apbNumber}&nbsp;-&nbsp;{pharmacyDetails.name}
            &nbsp;-&nbsp;{pharmacyDetails.address},&nbsp;
            {pharmacyDetails.city}&nbsp;
            {pharmacyDetails.zipCode}
          </b>
          Jour rayon min(m): {pharmacyDetails.minDistance}&nbsp;max(m): {pharmacyDetails.maxDistance}
          &nbsp;&nbsp;Nuit rayon min(m): {pharmacyDetails.minDistance2}&nbsp;max(m): {pharmacyDetails.maxDistance2}
          <br />
        </VerticalForm>
        <Container>
          <DataGrid
            id="pharmaciesList"
            dataSource={this.buildGridData()}
            showBorders
            allowColumnResizing
            onExporting={this.onExporting}
            rowAlternationEnabled={true}
            onRowDblClick={this.onPharmacySelected}
            width={'100%'}
          >
            <Export enabled={true} texts={{ exportAll: translate(TLCode.GRID_EXCEL_EXPORT) }} />
            <Sorting mode="multiple" />
            <FilterPanel visible={true} />
            <HeaderFilter visible={true} />
            <FilterRow visible={true} applyFilter={'auto'} />
            <SearchPanel visible={true} highlightCaseSensitive={true} width={400} />
            {/* <Scrolling mode={'virtual'} rowRenderingMode={'virtual'}/> */}
            <Column
              dataType="number"
              dataField="apbNumber"
              caption={translate(TLCode.PHARMACIES_ApbNum)}
              width={75}
            />
            <Column
              dataType="string"
              dataField="name"
              caption={translate(TLCode.PHARMACIES_PharmacyName)}
            />
            <Column
              dataType="string"
              dataField="address"
              caption={translate(TLCode.PHARMACIES_Address)}
              allowSorting={false}
            />
            <Column
              dataType="string"
              dataField="zipCode"
              caption={translate(TLCode.PHARMACIES_ZipCode)}
              width={60}
              allowSorting={false}
            />
            <Column
              dataType="string"
              dataField="city"
              caption={translate(TLCode.PHARMACIES_City)}
              width={120}
              allowSorting={false}
            />
            <Column dataType="number" dataField="level" caption={translate(TLCode.PHARMACIES_Level)} width={80} />
            {!isPharmacy &&
              <Column caption={translate(TLCode.PHARMACIES_Pairing)} alignment='center' width={70} cellRender={(cellData) => {
                const rowData = cellData.data;
                const isEqual = cellData.data.pairingAllowed !== cellData.data.pairingAllowedDef;
                return (
                  <div style={isEqual ? { backgroundColor: '#ffe8de' } : undefined}>
                    <CellCheck
                      flag={cellData.data.pairingAllowed!}
                      onValueChange={
                        (e) => this.openDialog(e, rowData, true)
                      }
                    />
                  </div>
                )
              }} />}
            {!isPharmacy &&
              <Column caption={translate(TLCode.PHARMACIES_Exchanges)} alignment='center' width={70} cellRender={(cellData) => {
                const rowData = cellData.data;
                const isEqual = cellData.data.exchangeAllowed !== cellData.data.exchangeAllowedDef;
                return (
                  <div style={isEqual ? { backgroundColor: '#ffe8de' } : undefined}>
                    <CellCheck
                      flag={cellData.data.exchangeAllowed!}
                      onValueChange={
                        (e) => this.openDialog(e, rowData, false)
                      }
                    />
                  </div>
                )
              }} />}
            <Column
              dataType="number"
              dataField="distance"
              caption={translate(TLCode.PHARMACIES_Distance)}
              width={150}
              sortIndex={1}
              defaultSortOrder="asc"
            />
            <Column dataType="string" dataField="anchor" caption={translate(TLCode.PHARMACIES_Anchor)} width={100} />
            <Column dataType="string" dataField="group" caption={translate(TLCode.PHARMACIES_Group)} width={80} />
            <Column
              cellRender={this.displayPharmacyStatusCell}
              caption={translate(TLCode.PHARMACY_Status)}
              width={60}
              alignment="center"
            />
            {!isPharmacy && (
              <Column caption="Actions" type="buttons" width={60}>
                <Button
                  hint={translate(TLCode.GENERAL_Edit)}
                  icon={'edit'}
                  onClick={(e) => {
                    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${e.row!.data.pharmacyId}`);
                  }}
                />
              </Column>
            )}
            <Pager
              visible={true}
              allowedPageSizes={[5, 10, 20, 50, 100]}
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true}
            />
            <Paging defaultPageSize={20} />
          </DataGrid>
        </Container>
        <Dialog onClose={() => this.cancelModification()} isOpen={this.state.popupVisible} canOutsideClickClose={false}>
          <div className={Classes.DIALOG_BODY}>
            <br />
            {this.state.data && (<p>{getConfirmationMessage(this.state.data)}</p>)}
            <br />
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button2 onClick={() => this.validateModification()} intent={Intent.SUCCESS} disabled={!this.state.data} loading={this.state.isLoading}>
                {translate(TLCode.GENERAL_Confirm)}
              </Button2>
              <Button2 onClick={() => this.cancelModification()} intent={Intent.DANGER} disabled={this.state.isLoading}>
                {translate(TLCode.GENERAL_Cancel)}
              </Button2>
            </div>
          </div>
        </Dialog>
      </Container>
    );
  }
}

export default withTranslate(NeighborsPanel);
